import { Component, Inject, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface NotificationData {
  type: NotificationType;
  title: string;
  message: string;
  duration: number;
}

@Component({
  selector: 'app-notification-snack',
  templateUrl: './notification-snack.component.html',
  styleUrls: ['./notification-snack.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationSnackComponent implements OnInit, OnDestroy {

  progress = 100;
  private _interval: any;
  private readonly _step = 50;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationData,
    private _ref: MatSnackBarRef<NotificationSnackComponent>
  ) {}

  ngOnInit(): void {
    // duration === 0 significa persistente: nunca se cierra solo
    if (this.data.duration === 0) { return; }

    const totalSteps = this.data.duration / this._step;
    const decrement = 100 / totalSteps;
    this._interval = setInterval(() => {
      this.progress = Math.max(0, this.progress - decrement);
      if (this.progress === 0) {
        clearInterval(this._interval);
        this.dismiss();
      }
    }, this._step);
  }

  ngOnDestroy(): void {
    clearInterval(this._interval);
  }

  dismiss(): void {
    this._ref.dismiss();
  }

  get icon(): string {
    const icons: Record<NotificationType, string> = {
      success: 'check_circle',
      error:   'error',
      warning: 'warning',
      info:    'info'
    };
    return icons[this.data.type] || 'info';
  }
}
